import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

/**
 * Emits <link rel="canonical" href="https://host/path" /> for the current route (href lowercased).
 * Uses pathname only (no query or hash) so tracking params do not create duplicate canonicals.
 */
export default function CanonicalLink() {
  const { pathname } = useLocation();

  const canonicalUrl = useMemo(() => {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    if (!origin) return "";
    const path = pathname || "/";
    const absolute = `${origin}${path.startsWith("/") ? path : `/${path}`}`;
    return absolute;
  }, [pathname]);

  if (!canonicalUrl) return null;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
